module.exports = __webpack_public_path__ + "2c54f8874fb7cc4a1f0aeafb3bf74edd.jpg";